import { connect } from 'react-redux';
import { State } from 'store/state';

import { ShortlistPage } from 'screens/ShortlistPage/ShortlistPage';
import {
  mapDispatchToProps,
  contactFormInitialValuesSelector,
} from 'helpers/contact';
import {
  favoritesAndShortlistDictSelector,
} from 'store/state/domainData/selectors/favorites';
import {
  isShortlistPoiLoadingSelector,
  lastViewedPoiIdsSelector,
  savedListingListSelector,
  lastContactedListingsListSelector,
} from 'store/state/selectors/shortlist';
import { navigateTo } from 'store/state/router/actions';


const mapStateToProps = (state: State) => ({
  poisByIds: favoritesAndShortlistDictSelector(state),
  lastContactedList: lastContactedListingsListSelector(state),
  savedListingList: savedListingListSelector(state),
  lastViewedIds: lastViewedPoiIdsSelector(state),
  isLoading: isShortlistPoiLoadingSelector(state),
  contactFormInitialValues: contactFormInitialValuesSelector(state),
});

export default connect(mapStateToProps, { ...mapDispatchToProps, navigate: navigateTo })(ShortlistPage);
